/**
 * Trims leading/trailing whitespace from string values, leaving non-string
 * values untouched. Used to clean CMS form inputs before sending them to the
 * backend so trailing spaces don't leak into stored data (e.g. city/county,
 * which feed the search-bar index terms).
 */
export const trimValue = <T>(value: T): T =>
  typeof value === "string" ? (value.trim() as T) : value;
